<template>
  <div class="bind-card">
    <template v-if="showDom">
      <!-- 绑定就诊卡或住院号的弹窗 -->
      <sn-popup :title="popupTitle" :cancel="false" @sendBack="sendBack" v-if="modelRegionMark === '0'">
        <div class="bind-card-region">
          <div class="integral-blank">
            <div class="sn-fc-grey91 sn-fw-bold info-header">当前需要绑卡的就诊人为：{{patientInfo.patientName}}</div>
            <!-- 表单，用于输入或选择绑定的信息 -->
            <el-form label-position="left" label-width="80px">
              <template v-for="item in cardCondition">
                <!-- 1 input(el-input)--remark.type: textarea、input 2 radio单选(el-radio-group) 3 select(el-select) -->
                <el-form-item :label="item.title + ':'" :key="item.key">
                  <template v-if="item.type === '1'">
                    <div class="sn-f-s-c">
                      <el-input :class="{'input-special': item.key === 'code'}" v-model="cardInfo[item.key]" :maxlength="item.remark.max" :placeholder="item.placeholder"></el-input>
                      <template v-if="item.key === 'code'">
                        <el-button type="primary" size="medium" :class="{'sn-bc-background1 sn-fc-text3 sn-bn': buttonLabel !== '获取动态码'}" @click="getVerificationCode">{{ buttonLabel }}</el-button>
                      </template>
                    </div>
                  </template>
                  <template v-else-if="item.type === '2'">
                    <div class="radio-blank">
                      <el-radio-group v-model="cardInfo[item.key]" @change="handleRadioChange">
                        <template v-for="(radio, radioIndex) in item.remark">
                          <el-radio :key="radioIndex" :label="radio.value">{{ radio.label }}</el-radio>
                        </template>
                      </el-radio-group>
                    </div>
                  </template>
                  <template v-else-if="item.type === '3'">
                    <el-select v-model="cardInfo[item.key]" :placeholder="item.placeholder">
                      <el-option v-for="(option, optionIndex) in item.remark" :key="optionIndex" :label="option.label" :value="option.label" @click.native="handleSelectCardChange(option)"></el-option>
                    </el-select>
                  </template>
                </el-form-item>
              </template>
            </el-form>
            <div class="sn-prompt sn-bn" v-if="promptInfo.length > 0">
              <div class="sn-prompt-title">温馨提示</div>
              <div class="sn-f-s-s sn-prompt-caption" :class="item.style" :key="i" v-for="(item, i) in promptInfo">
                <div class="sn-prompt-star">★</div>
                <div v-html="item.info"></div>
              </div>
            </div>
            <!-- 底部操作按钮 -->
            <div class="sn-f-e-c interaction-bottom">
              <div class="sn-f-c-c sn-pointer interaction" :class="'interaction-' + item.class" :key="index" v-for="(item, index) in interaction" @click="handlerInteraction(item)">
                {{ item.caption }}
              </div>
            </div>
          </div>
        </div>
      </sn-popup>
      <sn-popup title="校验方式" :cancel="false" @sendBack="sendBack" v-if="['1', '4', '6'].includes(modelRegionMark)">
        <div class="patient-filing-scheme">
          <div class="sn-padding-0 sn-fs-18 header-title">{{messages.PATIENT046}}</div>
          <div class="sn-padding-0 verification-method">
            <div v-for="(item, index) in way" :key="index">
              <template v-if="item.type === 'ocr'">
                <div class="sn-fs-16 mode-title">{{item.title}}</div>
                <div class="sn-pointer sn-f-e-c background-picture" :style="{'background-image': 'url(' + (imgUrl ? imgUrl : (ALI_CLOUD_DOMAIN_STATIC + item.background)) + ')'}" @click="uploadClick();">
                  <div v-if="!imgUrl">
                    <div class="sn-fs-20 sn-fc-text1 sn-fw-bold">点击上传</div>
                    <div class="sub-text">上传您身份证头像面</div>
                  </div>
                  <input type="file" multiple v-show="false" ref="fileInput" @change="uploadImg();" />
                </div>
                <div class="upload-require" v-if="captureCredential.title">
                  <span class="border-title">{{$sn.format.caption(captureCredential.title, [captureCredential.distinguish[idTypeFlag].title])}}</span>
                  <div class="sn-fs-20 sn-fc-text3">{{ captureCredential.caption }}</div>
                  <div class="require-line">
                    <div class="require-box" v-for="(el, index) in captureCredential.image" :key="index">
                      <div class="require-img">
                        <img :src="ALI_CLOUD_DOMAIN_STATIC + $sn.format.caption(el.url, [captureCredential.distinguish[idTypeFlag].key])" alt=""/>
                        <span class="iconfont" :class="el.status === '1' ? 'icon-xuanzhong' : 'icon-shanchu-mian- sn-fc-red1'"></span>
                      </div>
                      <div class="require-img-text">{{el.title}}</div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="sn-fs-16 mode-title">{{item.title}}</div>
                <template v-if="showPhoneMessage">
                  <div class="code-region">
                    您在医院预留的手机号有误，<span class="sn-fc-main sn-fs-16">请及时修改手机号。</span>
                  </div>
                </template>
                <template v-else>
                  <div class="code-region">
                    {{showText}}<span class="sn-fc-main">{{$sn.encrypted.phone(cardInfo.cardPhone)}}</span>上发送验证码。
                  </div>
                  <div class="sn-f-s-c verification-code">
                    <div class="verification-code-label">动态码：</div>
                    <el-input v-model="cardInfo.verifyCode" placeholder="请输入动态码" :maxlength="6"></el-input>
                    <el-button type="primary" size="medium" :class="{'sn-bc-background1 sn-fc-text3 sn-bn': buttonLabel !== '获取动态码'}" @click="getVerificationCode(cardInfo.cardPhone)">{{ buttonLabel }}</el-button>
                  </div>
                </template>
                <div class="sn-f-b-c submit-btn-box">
                  <div class="sn-pointer sn-fs-16 sn-fc-main" @click="unableEvent();">{{$sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_SDSL && type === '1' && modelRegionMark === '1' ? '修改院内档案信息手机号' : '无法获取动态码？'}}</div>
                  <el-button class="confirm-button" type="primary" size="medium" @click="navigateUrl(showPhoneMessage ? 'return' : 'submit')">下一步</el-button>
                </div>
              </template>
            </div>
          </div>
        </div>
      </sn-popup>
      <sn-popup title="在线建档" :cancel="false" @sendBack="sendBack" v-if="modelRegionMark === '2'">
        <div class="sn-f-col-b-c sn-f-1 patient-region">
          <div class="sn-f-1 integral">
            <div class="sn-f-col-c-c integral-blank">
              <el-form label-position="right" label-width="140px">
                <el-form-item :label="item.title" :required="item.required === '0'" v-for="item in optimizeForms(patientCondition)" :key="item.key">
                  <!-- 1 input(el-input)--remark.type: textarea、input 2 radio单选(el-radio-group) 3 select(el-select) 4 省市区组件(el-cascader) 5 日期(el-date-picker) -->
                  <template v-if="item.type === '1'">
                    <el-input v-model="item.value" :class="{'el-input-special': item.key === 'verifyCode', 'el-textarea-special': item.remark.type === 'textarea'}" :placeholder="item.placeholder"
                    :disabled="item.disabled === '0'" resize="none" autosize :maxlength="item.remark.max ? item.remark.max : 140" :type="item.remark.type"></el-input>
                    <el-button v-if="item.key === 'verifyCode'" type="primary" size="medium" :class="{'sn-bc-background1 sn-fc-text3 sn-bn': buttonLabel !== '获取动态码'}" @click="getVerificationCode()">{{ buttonLabel }}</el-button>
                  </template>
                  <template v-else-if="item.type === '2'">
                    <div class="radio-blank">
                      <el-radio-group v-model="item.value">
                        <template v-for="(radio, radioIndex) in item.remark.option">
                          <el-radio :key="radioIndex" :disabled="item.disabled === '0'" :label="radio.itemCode">{{ radio.itemName }}</el-radio>
                        </template>
                      </el-radio-group>
                    </div>
                  </template>
                  <template v-else-if="item.type === '3'">
                    <el-select v-model="item.value" :placeholder="item.placeholder" :disabled="item.disabled === '0'">
                      <el-option v-for="(option, optionIndex) in item.remark.option" :key="optionIndex" :label="option.itemName" :value="option.itemCode"></el-option>
                    </el-select>
                  </template>
                  <template v-else-if="item.type === '4'">
                    <el-cascader v-model="item.value" :options="item.remark.option" :props="defaultProps" ref="cascader" @change="handleCascadeChange"></el-cascader>
                  </template>
                  <template v-else-if="item.type === '5'">
                    <el-date-picker v-model="item.value" value-format="yyyy-MM-dd" :placeholder="item.placeholder" :disabled="item.disabled === '0'"></el-date-picker>
                  </template>
                </el-form-item>
              </el-form>
              <div class="operate-bottom">
                <div class="sn-f-e-c interaction-bottom interaction-bottom-only">
                  <div class="sn-f-c-c sn-pointer interaction" :class="'interaction-' + item.class" :key="index" v-for="(item, index) in interaction" @click.stop="handlerInteraction(item)">
                    {{ item.caption }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </sn-popup>
      <sn-popup title="在线建档" :cancel="false" @sendBack="sendBack" v-if="modelRegionMark === '3'">
        <div class="sn-f-col-b-c sn-f-1 patient-region">
          <div class="sn-f-1 integral">
            <div class="sn-f-col-c-c integral-blank">
              <el-form label-position="right" label-width="140px">
                <el-form-item :label="item.title" :required="item.required === '0'" v-for="item in optimizeForms(patientCondition)" :key="item.key">
                  <!-- 1 input(el-input)--remark.type: textarea、input 2 radio单选(el-radio-group) 3 select(el-select) 4 省市区组件(el-cascader) 5 日期(el-date-picker) -->
                  <template v-if="item.type === '1'">
                    <el-input v-model="item.value" :class="{'el-input-special': item.key === 'verifyCode', 'el-textarea-special': item.remark.type === 'textarea'}" :placeholder="item.placeholder"
                    :disabled="item.disabled === '0'" resize="none" autosize :maxlength="item.remark.max ? item.remark.max : 140" :type="item.remark.type"></el-input>
                    <el-button v-if="item.key === 'verifyCode'" type="primary" size="medium" :class="{'sn-bc-background1 sn-fc-text3 sn-bn': buttonLabel !== '获取动态码'}" @click="getVerificationCode()">{{ buttonLabel }}</el-button>
                  </template>
                  <template v-else-if="item.type === '2'">
                    <div class="radio-blank">
                      <el-radio-group v-model="item.value">
                        <template v-for="(radio, radioIndex) in item.remark.option">
                          <el-radio :key="radioIndex" :disabled="item.disabled === '0'" :label="radio.itemCode">{{ radio.itemName }}</el-radio>
                        </template>
                      </el-radio-group>
                    </div>
                  </template>
                  <template v-else-if="item.type === '3'">
                    <el-select v-model="item.value" :placeholder="item.placeholder" :disabled="item.disabled === '0'">
                      <el-option v-for="(option, optionIndex) in item.remark.option" :key="optionIndex" :label="option.itemName" :value="option.itemCode"></el-option>
                    </el-select>
                  </template>
                  <template v-else-if="item.type === '4'">
                    <el-cascader v-model="item.value" :options="item.remark.option" :props="defaultProps" ref="cascader" @change="handleCascadeChange"></el-cascader>
                  </template>
                  <template v-else-if="item.type === '5'">
                    <el-date-picker v-model="item.value" value-format="yyyy-MM-dd" :placeholder="item.placeholder" :disabled="item.disabled === '0'"></el-date-picker>
                  </template>
                </el-form-item>
              </el-form>
              <div class="operate-bottom">
                <div class="sn-f-e-c interaction-bottom interaction-bottom-only">
                  <div class="sn-f-c-c sn-pointer interaction" :class="'interaction-' + item.class" :key="index" v-for="(item, index) in interaction" @click.stop="handlerInteraction(item)">
                    {{ item.caption }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </sn-popup>
      <sn-popup title="修改身份信息" :cancel="false" @sendBack="sendBack" v-if="modelRegionMark === '5'">
        <div class="sn-f-col-b-c sn-f-1 patient-region">
          <div class="sn-f-1 integral">
            <div class="sn-f-col-c-c integral-blank">
              <el-form label-position="right" label-width="140px">
                <el-form-item :label="item.title" :required="item.required === '0'" v-for="item in optimizeForms(patientCondition)" :key="item.key">
                  <!-- 1 input(el-input)--remark.type: textarea、input 2 radio单选(el-radio-group) 3 select(el-select) 4 省市区组件(el-cascader) 5 日期(el-date-picker) -->
                  <template v-if="item.type === '1'">
                    <el-input v-model="item.value" :class="{'el-input-special': item.key === 'verifyCode', 'el-textarea-special': item.remark.type === 'textarea'}" :placeholder="item.placeholder"
                    :disabled="item.disabled === '0'" resize="none" autosize :maxlength="item.remark.max ? item.remark.max : 140" :type="item.remark.type"></el-input>
                    <el-button v-if="item.key === 'verifyCode'" type="primary" size="medium" :class="{'sn-bc-background1 sn-fc-text3 sn-bn': buttonLabel !== '获取动态码'}" @click="getVerificationCode()">{{ buttonLabel }}</el-button>
                  </template>
                  <template v-else-if="item.type === '2'">
                    <div class="radio-blank">
                      <el-radio-group v-model="item.value">
                        <template v-for="(radio, radioIndex) in item.remark.option">
                          <el-radio :key="radioIndex" :disabled="item.disabled === '0'" :label="radio.itemCode">{{ radio.itemName }}</el-radio>
                        </template>
                      </el-radio-group>
                    </div>
                  </template>
                  <template v-else-if="item.type === '3'">
                    <el-select v-model="item.value" :placeholder="item.placeholder" :disabled="item.disabled === '0'">
                      <el-option v-for="(option, optionIndex) in item.remark.option" :key="optionIndex" :label="option.itemName" :value="option.itemCode"></el-option>
                    </el-select>
                  </template>
                  <template v-else-if="item.type === '4'">
                    <el-cascader v-model="item.value" :options="item.remark.option" :props="defaultProps" ref="cascader" @change="handleCascadeChange"></el-cascader>
                  </template>
                  <template v-else-if="item.type === '5'">
                    <el-date-picker v-model="item.value" value-format="yyyy-MM-dd" :placeholder="item.placeholder" :disabled="item.disabled === '0'"></el-date-picker>
                  </template>
                </el-form-item>
              </el-form>
              <div class="operate-bottom">
                <div class="sn-f-e-c interaction-bottom interaction-bottom-only">
                  <div class="sn-f-c-c sn-pointer interaction" :class="'interaction-' + item.class" :key="index" v-for="(item, index) in interaction" @click.stop="handlerInteraction(item)">
                    {{ item.caption }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </sn-popup>
    </template>
  </div>
</template>

<script type="text/javascript">
import Swagger from '@/common/utils/swagger.js';
import * as Messages from '@/common/utils/messages';
import PatientShareMixin from '@/pages/patient/patient-share-mixin';
import * as Tools from '@/common/utils/tools';
import * as Constants from '@/common/utils/constants.js';

export default {
  mixins: [PatientShareMixin],
  name: 'bind-card',
  props: {
    // 门诊卡：1；住院卡：2
    type: {
      type: String,
      default: Constants.OUT_CARD_CLINIC_TYPE
    },
    // 要绑卡的就诊人id
    patientId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      interaction: [
        { caption: '取消', class: 'cancel', url: 'Cancel' },
        { caption: '确认', class: 'confirm', url: 'Confirm' }
      ], // 底部操作按钮
      messages: Messages, // 提示信息
      buttonLabel: '获取动态码', // 获取验证码按钮文本
      countSecond: 60, // 倒计时秒数，用于验证码失效倒计时
      bindCardInterval: null, // 定时器
      patientInfo: {}, // 就诊人信息
      showDom: false, // 是否显示dom
      cardCondition: [], // html上循环的表单信息
      defaultProps: {
        children: 'children',
        label: 'typeName',
        value: 'typeName'
      }, // cascader组件
      addressCascadeName: [], // cascader组件 地址name暂存
      addressCascadeCode: [], // cascader组件 地址code暂存
      captureCredential: {},
      idTypeFlag: '0',
      imgUrl: '',
      popupTitle: '绑定住院号',
      patientArray: [],
      photographStandard: 0,
      hospitalDigitalInformation: {}, // 字典数组
      cardInfo: {
        cardId: '', // 卡id
        cardNo: '', // 卡号
        clinicType: '', // 就诊类型
        cardType: '1', // 卡类型 1 门诊卡 2 省医保 3社保卡 4 市医保 5 身份证 6 健康卡
        cardPhone: '', // 卡手机号
        ocrContent: '', // 身份证图片*******
        patientId: '', // 就诊人唯一ID
        verifyCode: '', // 手机验证码*******
        verifyResult: '' // 人脸核验数据*******
      }, // 绑定卡片信息
      modelRegionMark: '0', // 0:绑卡 1:绑卡身份证校验（身份证 or 手机号） 2：建档方式（自费 or 医保） 3：补充信息 4：身份验证（上传身份证）5：修改信息（修改院内就诊卡预留手机号；通过填写 省市县、详细地址 + 新手机号）
      showPhoneMessage: false, // 是否显示手机号错误提示
      ormItems: {}, // 存储表单字段
      formatFormItems: {}, // 表单数据
      patientCondition: [], // html上循环的表单信息
      original: [],
      patientRecombination: [],
      markFailed: false,
      isDebug: false, // 是否是调试模式
      isCardVerificationPhone: '',
      way: [],
      verifyWay: {
        'ocr': {
          type: 'ocr',
          title: '认证方式{0}',
          label: '点击上传',
          subLabel: '上传您身份证头像面',
          button: '前往识别',
          background: '/hos/images/jzr_sfzsb_bj.png'
        },
        'phone': {
          type: 'phone',
          title: '认证方式{0}',
          label: '',
          subLabel: '',
          button: '',
          background: ''
        }
      },
      exhibitPhone: '', // 校验方式显示手机号
      showText: '我们会往您的建档手机号：'
    };
  },
  created: async function() {
    if (this.type === '1') this.popupTitle = this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL ? Messages.PATIENT044 : '绑定就诊卡';
    if (this.$sn.utils.getHospitalLocalStorage('Login_PatientList') && this.$sn.utils.getHospitalLocalStorage('Login_PatientList').length > 0) {
      this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
    }
    if (this.patientId) this.patientInfo = this.patientArray.filter(item => item.patientId === this.patientId)[0];
    else this.patientInfo = this.$sn.utils.getCurrentPatient() || {};
    await Tools.dict([this.perpetual.DICTIONARY_CODE_OCCUPATION,
      this.perpetual.DICTIONARY_CODE_CONTACT_RELATIONSHIP,
      this.perpetual.DICTIONARY_CODE_DOCUMENT_TYPE,
      this.perpetual.DICTIONARY_CODE_NATION,
      this.perpetual.DICTIONARY_CODE_CREATE_FILE_MODE,
      this.perpetual.DICTIONARY_CODE_INSURANCE_FILE_CODE]);
    this.hospitalDigitalInformation = this.$sn.utils.getHospitalSessionStorage('HospitalDigitalInformation') ? this.$sn.utils.getHospitalSessionStorage('HospitalDigitalInformation') : {};
    this.captureCredential = await this.patient_mixin_getCaptureCredential('/hos/ui/caption/patient/capture-credential.js');
    this.patientRecombination = await this.patient_mixin_form('create');
    this.patient_mixin_getPromptInfo(this.type === '1' ? 'out' : 'in', 'bind-card');
    this.handlePatientInfo();
    this.initial();
  },
  watch: {
    'modelRegionMark': function(value) {
      this.buttonLabel = '获取动态码';
      this.countSecond = 60;
      if (value === '1') {
        if (this.type === '1' && this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL) this.initial('1');
        else {
          if (this.$sn.validate.empty(this.cardInfo.cardPhone) || !this.$sn.validate.phone(this.cardInfo.cardPhone)) this.showPhoneMessage = true;
          else {
            this.$set(this.cardInfo, 'verifyCode', '');
            this.$set(this.cardInfo, 'ocrContent', '');
          }
        }
      }
      else if (['2', '3', '5'].includes(value)) {
        this.patientInfo.patientPhone = '';
        if (['2', '3'].includes(value) && !this.$sn.validate.empty(this.original)) this.patientCondition = JSON.parse(this.original);
      }

      if (['1', '4', '6'].includes(value)) {
        if (['1', '6'].includes(value)) {
          if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL && this.type === '1') this.obtainVerify();
          else this.obtainVerify();
        }
        else this.obtainVerify();
      }
    }
  },
  mounted() {},
  computed: {},
  methods: {
    // 获取校验方式
    async obtainVerify() {
      // 认证方式开始
      let current = ['ocr'];
      const typeMap = {
        '1': this.$sn.format.caption('addition{0}CardVerify', [this.type === Constants.OUT_CARD_CLINIC_TYPE ? 'Out' : 'In']),
        '4': 'createFileVerify'
      };
      if (this.modelRegionMark && typeMap[this.modelRegionMark]) {
        if (!this.$sn.validate.empty(this.$sn.getConfig(typeMap[this.modelRegionMark]))) {
          if (this.$sn.validate.array(this.$sn.getConfig(typeMap[this.modelRegionMark]))) {
            current = this.$sn.getConfig(typeMap[this.modelRegionMark]).filter(e => e !== 'face');
          }
        }
      }
      const filterWay = current.map(key => this.verifyWay[key]);
      filterWay.map((el, index) => {
        el.title = filterWay.length > 1 ? this.$sn.format.caption(el.title, [this.$sn.format.nToC(index + 1)]) : '认证方式';
      });
      this.way = filterWay;
      // 认证方式结束
      const sift = this.way.filter(result => result.type === 'phone');
      if (sift.length > 0) {
        if (this.modelRegionMark === '4') {
          if (this.$sn.validate.empty(this.cardInfo.cardPhone)) {
            this.cardInfo.cardPhone = this.$sn.utils.getLoginPhone();
            this.showText = '我们会往您的登录手机号：';
          }
        }
        if (this.$sn.validate.empty(this.cardInfo.cardPhone) || !this.$sn.validate.phone(this.cardInfo.cardPhone)) this.showPhoneMessage = true;
      }
    },
    // 初始化页面数据
    async initial(type) {
      const item = this.patientInfo ? this.patientInfo : {};
      this.$set(item, 'insureCardFlag', '');
      this.$set(item, 'insureCardNo', '');
      this.$set(item, 'patientType', '');
      this.$set(item, 'ocrContent', '');
      this.$set(item, 'verifyCode', '');
      this.$set(item, 'patientPhone', '');
      this.patientInfo = item;
      this.cardCondition = [];
      let handle = [];
      const recombination = await this.patient_mixin_form('card');
      // type:1 outCardVerifyCondition、outCardVerifyConditionType，2 inCardVerifyCondition、inCardVerifyConditionType
      const cardVerifyCondition = this.type === '1' ? this.$sn.getConfig('outCardVerifyCondition') : this.$sn.getConfig('inCardVerifyCondition');
      const cardVerifyConditionType = this.type === '1' ? this.$sn.getConfig('outCardVerifyConditionType') : this.$sn.getConfig('inCardVerifyConditionType');
      if (cardVerifyCondition && cardVerifyCondition.length > 0) {
        // 遍历 cardVerifyCondition
        cardVerifyCondition.forEach(condition => {
          let found = false;
          // 寻找是否已经存在于 recombination 中
          for (let i = 0; i < recombination.length; i++) {
            if (recombination[i].key === condition.key) {
              recombination[i] = {
                ...recombination[i], // 保留原来的其他属性
                ...condition // 使用 cardVerifyCondition 中的数据进行更新
              };
              found = true;
            }
          }
          // 如果没找到匹配的 key，则追加到 recombination 中
          if (!found) recombination.push(condition);
        });
      }
      const integration = [];
      if (recombination && recombination.length > 0) {
        if (cardVerifyConditionType && cardVerifyConditionType.length > 0) {
          cardVerifyConditionType.map((resultKey, index) => {
            const exchange = recombination.find(item => item.key === resultKey);
            this.$set(exchange, 'sort', index + 1);
            if (exchange && exchange.key) integration.push({ ...exchange });
          });
        }
      }
      if (integration && integration.length > 0) this.cardCondition = this.$sn.format.digitalSort(integration);
      if (this.shareInterfaceObtain()) {
        this.$sn.assembly.loading(true);
        const result = await this.patient_mixin_getCardInfoByCondition(this.type, '1', this.patientInfo);
        this.$sn.assembly.loading(false);
        // result.code 0: 有卡，1：选择建档方式，2：补充信息
        if (result.code === 0) {
          handle = result.data;
          if (handle && handle.length > 0 && integration && integration.length > 0) {
            integration.forEach(item => {
              if (item.key === 'cardNo') {
                handle.forEach(card => {
                  if (this.$sn.getConfig('isShowIdCardNoInCaseMedicareCard') && ['1', '4'].includes(card.cardType)) {
                    this.$set(card, 'label', this.patientInfo.patientIdCardNo);
                  }
                  else this.$set(card, 'label', this.$sn.getConfig('isOpenEncryptedCard') ? card.cardNoEncrypt : card.cardNo);
                  this.$set(card, 'value', card.cardId);
                });
                item.remark = handle;
                Object.keys(this.cardInfo).forEach(key => {
                  if (handle[0][key]) this.cardInfo[key] = handle[0][key];
                });
                if (this.$sn.getConfig('isShowIdCardNoInCaseMedicareCard') && ['1', '4'].includes(handle[0].cardType)) {
                  this.cardInfo[item.key] = this.patientInfo.patientIdCardNo;
                }
                else this.cardInfo[item.key] = this.$sn.getConfig('isOpenEncryptedCard') ? handle[0].cardNoEncrypt : handle[0].cardNo;
              }
            });
            this.showDom = true;
          }
        }
        else if ([1, 2].includes(result.code)) {
          // modelRegionMark: '0' // 0:绑卡 1:绑卡身份证校验（身份证 or 手机号） 2：建档方式（自费 or 医保） 3：补充信息 4：身份验证（上传身份证）5：修改信息（修改院内就诊卡预留手机号；通过填写 省市县、详细地址 + 新手机号）
          this.modelRegionMark = result.code === 1 ? '2' : '3';
          this.showDom = true;
        }
        else {
          this.$sn.assembly.toast({
            caption: result.msg,
            mode: 'success',
            success: () => {
              this.$emit('sendBack', false);
            }
          });
          return false;
        }
        if (type === '1') this.obtainVerify();
      }
      else this.showDom = this.cardCondition.length > 0;
      if (!this.showDom) this.$emit('sendBack', false);
    },
    // 判断是否通过接口获取卡信息
    shareInterfaceObtain() {
      // outCardInterfaceAndWrite or inCardInterfaceAndWrite ： 1: 接口返回；2：手输卡号
      // 定义一个映射，用于根据props中入参 type 类型 返回 true or false
      const typeMap = {
        [Constants.OUT_CARD_CLINIC_TYPE]: this.$sn.getConfig('outCardInterfaceAndWrite') === '1',
        [Constants.IN_CARD_CLINIC_TYPE]: this.$sn.getConfig('inCardInterfaceAndWrite') === '1'
      };
      return typeMap[this.type];
    },
    // 倒计时
    startCountDown() {
      this.bindCardInterval = setInterval(() => {
        if (this.countSecond > 0) {
          this.countSecond--; // 每隔1秒将倒计时减少1
          this.buttonLabel = '重新发送' + this.countSecond + 's';
        }
        else {
          // 如果倒计时结束则清除定时器
          if (this.bindCardInterval) clearInterval(this.bindCardInterval);
          this.buttonLabel = '获取动态码';
          this.countSecond = 60;
        }
      }, 1000);
    },
    // 获取验证码
    getVerificationCode(phone) {
      let patientPhone = '';
      let codeType = '5';
      if (this.$sn.validate.empty(phone)) {
        if (this.optimizeForms(this.patientCondition).filter(el => el.key === 'patientPhone').length > 0) {
          patientPhone = this.optimizeForms(this.patientCondition).filter(el => el.key === 'patientPhone')[0].value;
        }
      }
      else {
        patientPhone = phone;
        codeType = ['4', '6'].includes(this.modelRegionMark) ? '5' : '6';
      }
      if (this.$sn.validate.empty(patientPhone)) {
        // 弹窗提示消息 动态码短信已发送至
        this.getShowToast(this.$sn.format.caption(Messages.PATIENT040, ['手机号']));
        return false;
      }
      if (this.buttonLabel === '获取动态码') {
        if (this.$sn.validate.phone(patientPhone)) {
          const params = {
            url: Swagger.sendCode,
            method: 'POST',
            header: true,
            data: JSON.stringify({
              hosId: this.$sn.utils.getHospitalId(),
              mobile: patientPhone,
              platformType: this.$sn.utils.getPlatformType(),
              projectType: '',
              codeType: codeType
            })
          };
          this.$sn.assembly.loading(true);
          this.$sn.utils.ordinaryRequest(params).then(result => {
            this.$sn.assembly.loading(false);
            if (result && result.code === 0) {
              this.startCountDown();
              // 弹窗提示消息 动态码短信已发送至
              this.getShowToast(this.$sn.format.caption(Messages.PATIENT023, [this.$sn.encrypted.phone(patientPhone)]));
            }
            else this.getShowToast(result && result.msg ? result.msg : Messages.C001);
          });
        }
        else this.getShowToast(Messages.C013);
      }
    },
    // 选择卡类型
    handleRadioChange(type = 'card', value) {
      if (type === 'card') {
        this.cardInfo.cardNo = '';
        // 卡类型 1 门诊卡 2 省医保 3社保卡 4 市医保 5身份证 6 健康卡
        if (value === '5') this.cardInfo.cardNo = { ...this.patientInfo.patientIdCardNo };
        else if (value === '6') this.getPatientHealthCardInfo(this.patientInfo.patientIdCardNo);
      }
    },
    // 选择卡信息
    handleSelectCardChange(cardInfo) {
      Object.keys(this.cardInfo).forEach(key => {
        if (cardInfo[key]) this.cardInfo[key] = cardInfo[key];
      });
    },
    // 根据身份证号获取电子健康卡号信息
    getPatientHealthCardInfo(patientIdCardNo) {
      const params = {
        url: Swagger.getHealthCardInfoByIdCardSerial,
        method: 'POST',
        header: true,
        data: JSON.stringify({
          patientIdCardNo: patientIdCardNo
        })
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0 && result.data) this.cardInfo.cardNo = result.data.healthyCardCode;
        else this.getShowToast(result && result.msg ? result.msg : Messages.C001);
      });
    },
    // 操作就诊人的信息
    async handlePatientInfo() {
      const recombination = this.patientRecombination;
      const patientVerifyCondition = [
        {
          type: '2',
          title: '建档方式',
          key: 'insureCardFlag',
          placeholder: '请选择',
          remark: {
            option: [],
            url: 'create_file_mode'
          }
        },
        {
          type: '2',
          title: '医保类型',
          key: 'patientType',
          placeholder: '请选择',
          remark: {
            option: [],
            url: 'insurance_file_code'
          }
        },
        {
          type: '1',
          title: '医保卡号',
          key: 'insureCardNo',
          placeholder: '请输入医保卡号',
          remark: {
            type: 'text',
            max: -1
          }
        },
        {
          type: '3',
          title: '职业',
          key: 'occupation',
          placeholder: '请选择',
          remark: {
            option: [],
            url: 'occupation'
          }
        }
      ];
      // 遍历 patientVerifyCondition
      if (patientVerifyCondition && patientVerifyCondition.length > 0) {
        patientVerifyCondition.forEach(condition => {
          let found = false;
          // 寻找是否已经存在于 recombination 中
          for (let i = 0; i < recombination.length; i++) {
            if (recombination[i].key === condition.key) {
              recombination[i] = {
                ...recombination[i], // 保留原来的其他属性
                ...condition // 使用 patientVerifyCondition 中的数据进行更新
              };
              found = true;
            }
          }
          // 如果没找到匹配的 key，则追加到 recombination 中
          if (!found) recombination.push(condition);
        });
      }
      recombination.forEach(item => {
        if (item.key === 'code') {
          item.key = 'verifyCode';
          item.title = '动态码';
          item.placeholder = '请输入动态码';
        }
      });
      this.tackle([...recombination]);
    },
    // 处理表单数据
    async tackle(recombination) {
      const integration = [];
      if (recombination && recombination.length > 0) {
        for (const element of recombination) {
          this.$set(element, 'required', '0');
          this.$set(element, 'disabled', '1');
          if (this.$sn.validate.object((element.remark)) && element.remark.url) {
            if (['nationality', 'province-city-district'].includes(element.remark.url)) {
              element.remark.option = await this.patient_mixin_getOssStaticResources((element.remark.url));
              if (element.remark.url === 'nationality') {
                element.remark.option.forEach(item => {
                  item.itemName = item.typeName;
                  item.itemCode = item.typeCode;
                });
              }
            }
            else {
              element.remark.option = this.hospitalDigitalInformation[element.remark.url];
              if (element.remark.url === Constants.DICTIONARY_CODE_CREATE_FILE_MODE) {
                element.remark.option.forEach(item => {
                  const code = {
                    '0': 'N',
                    '1': 'Y'
                  };
                  item.itemCode = code[item.itemCode];
                });
              }
            }
          }
          if (element.key === 'nationality') element.remark.option = element.remark.option.filter(item => item.id && item.itemCode && item.itemName);
        }
        let general = ['patientName', 'patientIdCardNo', 'insureCardFlag', 'patientType', 'insureCardNo', 'nation', 'occupation', 'patientPhone', 'verifyCode', 'habitation', 'detailAddress'];
        if (['1', '3'].includes(this.patientInfo.idCardType)) {
          general = ['patientName', 'patientIdCardNo', 'insureCardFlag', 'patientType', 'insureCardNo', 'occupation', 'patientPhone', 'verifyCode', 'habitation', 'detailAddress'];
        }
        const patientVerifyConditionType = general;
        if (patientVerifyConditionType && patientVerifyConditionType.length > 0) {
          patientVerifyConditionType.forEach((resultKey, index) => {
            const exchange = recombination.find(item => item.key === resultKey);
            if (exchange && exchange.key) {
              this.$set(exchange, 'sort', index + 1);
              integration.push({ ...exchange });
            }
          });
        }
        if (this.patientInfo.patientId) {
          integration.forEach(formItem => {
            formItem.disabled = ['patientName', 'patientIdCardNo'].includes(formItem.key) ? '0' : '1';
            if (!['patientName', 'patientIdCardNo'].includes(formItem.key)) {
              if (this.patientInfo[formItem.key]) formItem.value = this.patientInfo[formItem.key];
            }
            else {
              if (this.patientInfo[formItem.key]) {
                if (formItem.key === 'patientName') formItem.value = this.patientInfo.nameEncrypt;
                if (formItem.key === 'patientIdCardNo') formItem.value = this.patientInfo.idCardEncrypt;
              }
            }
            if (this.patientInfo.patientAddress && (formItem.key === 'habitation' || formItem.key === 'detailAddress')) {
              const regionInitial = [this.patientInfo.province, this.patientInfo.city, this.patientInfo.county].filter(address => address);
              if (formItem.key === 'habitation') {
                const province = this.patientInfo.province;
                const city = this.patientInfo.city;
                const county = this.patientInfo.county;
                // 地址如果传的是code的情况下
                // if (this.patientInfo.province && formItem.remark.option.filter(province => province.typeName === this.patientInfo.province).length > 0) {
                //   province = formItem.remark.option.filter(province => province.typeName === this.patientInfo.province)[0].typeCode;
                // }
                // formItem.remark.option.forEach(father => {
                //   if (father.children.length > 0) {
                //     if (this.patientInfo.city && father.children.filter(city => city.typeName === this.patientInfo.city).length > 0) {
                //       city = father.children.filter(city => city.typeName === this.patientInfo.city)[0].typeCode;
                //     }
                //     father.children.forEach(son => {
                //       if (this.$sn.validate.object(son.children)) {
                //         county = son.typeCode;
                //       }
                //       if (this.$sn.validate.array(son.children)) {
                //         if (son.children.length > 0) {
                //           if (this.patientInfo.county && son.children.filter(county => county.typeName === this.patientInfo.county).length > 0) {
                //             county = son.children.filter(county => county.typeName === this.patientInfo.county)[0].typeCode;
                //           }
                //         }
                //       }
                //     });
                //   }
                // });
                this.addressCascadeName = [province, city, county];
                formItem.value = [province, city, county];
              }
              if (formItem.key === 'detailAddress') formItem.value = regionInitial.length > 0 ? this.patientInfo.patientAddress.replace(regionInitial.join(''), '') : this.patientInfo.patientAddress;
            }
          });
        }
        this.patientCondition = integration;
        this.original = JSON.stringify(integration);
      }
    },
    // 优化表单数据
    optimizeForms(array) {
      let formArray = array;
      // 过滤数组
      const fieldArray = ['patientName', 'patientIdCardNo', 'insureCardFlag', 'patientType', 'insureCardNo', 'nation', 'occupation', 'patientPhone', 'verifyCode', 'habitation', 'detailAddress'];
      if (this.modelRegionMark === '2') {
        const single = array.filter(obj => ['insureCardFlag'].includes(obj.key));
        if (single.length > 0) {
          if (single[0].value === 'Y') formArray = array.filter(obj => fieldArray.includes(obj.key));
          else formArray = array.filter(obj => ['patientName', 'patientIdCardNo', 'insureCardFlag'].includes(obj.key));
        }
      }
      else if (this.modelRegionMark === '5') formArray = array.filter(obj => ['patientPhone', 'verifyCode', 'habitation', 'detailAddress'].includes(obj.key));
      else formArray = array.filter(obj => !['insureCardFlag', 'patientType', 'insureCardNo'].includes(obj.key));
      return formArray;
    },
    // 获取不到验证码
    unableEvent() {
      if (this.type === '1' && this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL && this.modelRegionMark === '1') {
        this.$sn.assembly.modal({
          caption: '是否允许修改手机号或地址',
          success: (modal) => {
            if (modal.confirm) this.modelRegionMark = '5';
          }
        });
      }
      else {
        this.$sn.assembly.modal({
          title: '获取不到动态码？',
          caption: Messages.PATIENT047,
          captionConfirm: '我知道了',
          isCancel: false
        });
      }
    },
    // 省市区联动
    handleCascadeChange(value) {
      this.addressCascadeName = this.$sn.validate.array(this.$refs.cascader) ? this.$refs.cascader[0].getCheckedNodes()[0].pathLabels : this.$refs.cascader.getCheckedNodes()[0].pathLabels;
      this.addressCascadeCode = value;
    },
    // 点击上传按钮
    uploadClick() {
      this.cardInfo.ocrContent = '';
      this.cardInfo.verifyCode = '';
      this.patientInfo.ocrContent = '';
      this.patientInfo.verifyPhone = '';
      this.photographStandard = 0;
      this.$refs.fileInput[0].value = '';
      this.$refs.fileInput[0].click();
    },
    // 上传图片
    uploadImg() {
      if (this.$refs.fileInput[0].files.length > 1) {
        this.getShowToast(this.$sn.format.caption(Messages.C005, ['一']));
        return false;
      }
      if (this.$refs.fileInput[0].files.length === 0) return false;
      this.$sn.assembly.loading(true);
      Tools.uploadFile(this.perpetual.UPLOAD_TYPE_JZR, this.$refs.fileInput[0].files, 1, this.perpetual.IMAGE_SIZE, this.uploadImageCallBack);
    },
    // 上传图片回调
    async uploadImageCallBack(type, result, file) {
      this.$sn.assembly.loading(false);
      if (type) {
        this.photographStandard++;
        if (this.photographStandard === file.length) {
          this.$sn.assembly.loading(true);
          const single = await Tools.getPrivateResourceUrl(this.perpetual.UPLOAD_TYPE_JZR, file[0].trajectory.split(';'));
          this.$sn.assembly.loading(false);
          this.imgUrl = single[0];
          this.cardInfo.verifyCode = '';
          if (['4', '6'].includes(this.modelRegionMark)) this.patientInfo.ocrContent = this.imgUrl;
          if (this.modelRegionMark === '1') {
            this.cardInfo.ocrContent = this.imgUrl;
            this.bindCardInfo();
          }
          else if (this.modelRegionMark === '4') this.addOnlinePatientUp();
          else if (this.modelRegionMark === '6') this.modifyPatientInfo();
        }
      }
      else this.getShowToast(result.msg);
    },
    // 提交表单
    formatPatientAndFormItems(array) {
      this.patientInfo.nationality = '';
      this.patientInfo.nationalityCode = '';
      this.patientInfo.province = '';
      this.patientInfo.city = '';
      this.patientInfo.county = '';
      this.patientInfo.patientAddress = '';
      array.forEach(formItem => {
        if (!['patientName', 'patientIdCardNo', 'nationality', 'nation', 'habitation', 'detailAddress'].includes(formItem.key)) this.patientInfo[formItem.key] = formItem.value;
        if (['occupation'].includes(formItem.key)) {
          this.patientInfo.occupation = formItem.remark.option.filter(item => item.itemCode === formItem.value)[0]?.itemName || '';
          this.patientInfo.occupationCode = formItem.value;
        }
        if (['1', '3'].includes(this.patientInfo.idCardType) && formItem.key === 'nationality') {
          this.patientInfo.nation = '';
          this.patientInfo.nationality = formItem.remark.option.filter(item => item.itemCode === formItem.value)[0]?.itemName || '';
          this.patientInfo.nationalityCode = formItem.value;
        }
        if (['0', '2', '4'].includes(this.patientInfo.idCardType) && formItem.key === 'nation') this.patientInfo.nation = formItem.remark.option.find(item => item.itemCode === formItem.value)?.itemName || '';
        if (['habitation', 'detailAddress'].includes(formItem.key)) {
          // addressCascadeName 传汉字 addressCascadeCode 传code
          if (this.addressCascadeName && this.addressCascadeName.length > 0) {
            this.patientInfo.province = this.addressCascadeName[0] ? this.addressCascadeName[0] : '';
            this.patientInfo.city = this.addressCascadeName[1] ? this.addressCascadeName[1] : '';
            this.patientInfo.county = this.addressCascadeName[2] ? this.addressCascadeName[2] : '';
            this.patientInfo.patientAddress = this.addressCascadeName.join('') + (['detailAddress'].includes(formItem.key) ? formItem.value : '');
            this.patientInfo.patientPresentAddress = this.patientInfo.patientAddress;
          }
        }
      });
    },
    // 确认、提交操作
    handlerInteraction(item) {
      if (item.url === 'Confirm') {
        if (['0', '1'].includes(this.modelRegionMark)) {
          if (this.modelRegionMark === '1' && this.cardCondition.filter(result => this.$sn.validate.empty(this.cardInfo[result.key])).length > 0) {
            this.getShowToast(Messages.PATIENT061);
            return false;
          }
          // 绑卡
          this.bindCardInfo();
        }
        else if (['2', '3', '5'].includes(this.modelRegionMark)) {
          const patientCondition = this.optimizeForms(this.patientCondition);
          const single = patientCondition.filter(result => this.$sn.validate.empty(result.value));
          if (single.length > 0) {
            this.getShowToast(Messages.PATIENT061);
            return false;
          }
          if (patientCondition.filter(result => result.key === 'insureCardFlag' && result.value === 'N').length > 0) {
            this.modelRegionMark = '3';
            return false;
          }
          if (patientCondition.filter(result => result.key === 'patientPhone' && !this.$sn.validate.phone(result.value)).length > 0) {
            this.getShowToast(this.$sn.format.caption(Messages.SEARCH001, ['正确的手机号']));
            return false;
          }
          this.formatPatientAndFormItems(patientCondition);
          if (['2', '3'].includes(this.modelRegionMark)) this.addOnlinePatientUp();
          else if (this.modelRegionMark === '5') this.modifyPatientInfo();
        }
      }
      else if (item.url === 'Cancel') {
        // 0:绑卡 1:绑卡身份证校验（身份证 or 手机号） 2：建档方式（自费 or 医保） 3：补充信息 4：身份验证（上传身份证）5：修改信息（修改院内就诊卡预留手机号；通过填写 省市县、详细地址 + 新手机号）
        if (this.modelRegionMark === '5' && !this.markFailed) this.modelRegionMark = '1';
        else if (this.modelRegionMark === '3' && (this.$sn.getConfig('createFileMode').indexOf('1') !== -1)) this.modelRegionMark = '2';
        else this.sendBack(false);
      }
    },
    // 绑卡
    bindCardInfo() {
      // 门诊拉卡医院绑卡的时候不允许卡号或卡id为空
      if (this.type === Constants.OUT_CARD_CLINIC_TYPE && this.$sn.getConfig('isOutBindCardOperationCardNoOrCardIdEmpty')) {
        if (this.$sn.validate.empty(this.cardInfo.cardId) || this.$sn.validate.empty(this.cardInfo.cardNo)) {
          // captionConfirm: '确定按钮文案' captionCancel: '取消按钮文案' title: '标题' caption: '展示文本' isConfirm: true(是否显示确定按钮) true(是否显示取消按钮)
          this.$sn.assembly.modal({
            caption: Messages.PATIENT027,
            isCancel: false
          });
          return false;
        }
      }
      if (this.$sn.validate.empty(this.cardInfo.cardNo)) {
        this.getShowToast(Messages.PATIENT061);
        return false;
      }
      if (this.$sn.validate.empty(this.cardInfo.patientId)) this.cardInfo.patientId = this.patientInfo.patientId;
      if (this.$sn.validate.empty(this.cardInfo.clinicType)) this.cardInfo.clinicType = this.type;
      const params = {
        url: this.isDebug ? Swagger.bindCardInfo : Swagger.upgradeBindCardInfo,
        method: 'POST',
        header: true,
        data: JSON.stringify(this.patient_mixin_valueCardTransmission(this.cardInfo))
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0 && result.data) {
          const exchange = {};
          this.$set(exchange, this.type === '1' ? 'outCardId' : 'inCardId', result.data.cardId);
          this.$set(exchange, this.type === '1' ? 'outCardNo' : 'inCardNo', result.data.cardNo);
          this.$set(exchange, this.type === '1' ? 'patOutCardNoEncrypt' : 'patInCardNoEncrypt', result.data.cardNoEncrypt);
          this.$set(exchange, this.type === '1' ? 'overdueState' : 'inOverdueState', '0');
          if (this.$sn.getConfig('isBindCardChangePatientInfo') && result.data.expand) {
            if (result.data.expand) {
              if (result.data.expand.hidePatientName) this.$set(exchange, 'nameEncrypt', result.data.expand.hidePatientName);
              if (result.data.expand.patientName) this.$set(exchange, 'patientName', result.data.expand.patientName);
              if (result.data.expand.patSex) this.$set(exchange, 'patientSex', result.data.expand.patSex);
            }
          }
          Tools.modifyPatientInfo(this.patientInfo.patientId, exchange);
          this.$sn.assembly.toast({
            caption: this.$sn.format.caption(Messages.C016, ['绑卡']),
            mode: 'success',
            success: () => {
              this.sendBack(true, this.$sn.utils.getCurrentPatient());
            }
          });
        }
        else {
          if (result && result.code && result.code === 60001) {
            this.modelRegionMark = this.shareInterfaceObtain() ? '1' : '4';
            return false;
          }
          else this.getShowToast(result && result.msg ? result.msg : Messages.C001);
        }
      });
    },
    // 修改就诊人
    modifyPatientInfo() {
      this.$set(this.patientInfo, 'updateType', '1');
      const params = {
        url: this.isDebug ? Swagger.modifyPatientInfo : Swagger.upgradeModifyPatientInfo,
        method: 'POST',
        header: true,
        data: JSON.stringify(this.patient_mixin_valueModifyTransmissionInformation(this.patientInfo))
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.data && result.code === 0) {
          this.$sn.assembly.toast({
            caption: this.$sn.format.caption(Messages.C016, ['修改手机号']),
            mode: 'success',
            success: () => {
              this.modelRegionMark = '1';
            }
          });
        }
        else {
          if (result && result.code && result.code === 60001) {
            // 0:绑卡 1:绑卡身份证校验（身份证 or 手机号） 2：建档方式（自费 or 医保） 3：补充信息 4：身份验证（上传身份证）5：修改信息（修改院内就诊卡预留手机号；通过填写 省市县、详细地址 + 新手机号）
            this.modelRegionMark = '6';
            return false;
          }
          else this.getShowToast(result && result.msg ? result.msg : Messages.C001);
        }
      });
    },
    // 在线建档
    addOnlinePatientUp() {
      this.markFailed = true;
      if (this.$sn.validate.empty(this.patientInfo.accountId)) this.patientInfo.accountId = this.$sn.utils.getAccountId();
      if (this.$sn.validate.empty(this.patientInfo.projectType)) this.$set(this.patientInfo, 'projectType', this.$sn.utils.getProjectType());
      if (this.$sn.validate.empty(this.patientInfo.hospitalId)) this.$set(this.patientInfo, 'hospitalId', this.$sn.getConfig('hosHealthCardId'));
      if (this.patientInfo.insureCardFlag !== 'Y') {
        this.$set(this.patientInfo, 'insureCardNo', '');
        this.$set(this.patientInfo, 'patientType', '');
      }
      if (this.modelRegionMark === '4') {
        if (this.cardInfo.verifyCode) this.$set(this.patientInfo, 'verifyPhone', this.cardInfo.verifyCode);
      }
      const params = {
        url: this.isDebug ? Swagger.createPatientCardInfo : Swagger.upgradeCreatePatientCardInfo,
        method: 'POST',
        header: true,
        data: JSON.stringify(this.patientInfo)
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0 && result.data) {
          if (this.patientArray.length === 0) this.$sn.utils.setHospitalLocalStorage('Login_PatientList', this.patientArray.push(result.data));
          Tools.modifyPatientInfo(this.patientInfo.patientId, result.data);
          this.$sn.assembly.toast({
            caption: this.$sn.format.caption(Messages.C016, ['在线建档']),
            mode: 'success',
            success: () => {
              this.sendBack(true, this.$sn.utils.getCurrentPatient());
            }
          });
        }
        else {
          this.markFailed = true;
          if (result && result.code && result.code === 60001) {
            this.modelRegionMark = '4';
            return false;
          }
          else this.getShowToast(result && result.msg ? result.msg : Messages.C001);
        }
      });
    },
    // 回传父组件
    sendBack(type, item) {
      // 0:绑卡 1:绑卡身份证校验（身份证 or 手机号） 2：建档方式（自费 or 医保） 3：补充信息 4：身份验证（上传身份证）5：修改信息（修改院内就诊卡预留手机号；通过填写 省市县、详细地址 + 新手机号）
      if (this.bindCardInterval) clearInterval(this.bindCardInterval);
      this.$emit('sendBack', type, type ? item : '');
    },
    // 单纯的弹窗显示信息
    getShowToast(msg) {
      this.$sn.assembly.toast({
        caption: msg
      });
    },
    navigateUrl(url) {
      if (this.$sn.validate.empty(url)) return false;
      if (url === 'submit') {
        this.cardInfo.ocrContent = '';
        this.patientInfo.ocrContent = '';
        if (this.$sn.validate.empty(this.cardInfo.verifyCode)) {
          this.getShowToast(this.$sn.format.caption(Messages.PATIENT040, ['动态码']));
          return false;
        }
        if (this.modelRegionMark === '1') this.bindCardInfo();
        else if (this.modelRegionMark === '6') this.modifyPatientInfo();
        else this.addOnlinePatientUp();
      }
      else if (url === 'return') {
        this.cardInfo.ocrContent = '';
        this.cardInfo.verifyCode = '';
        if (this.modelRegionMark === '1') {
          this.modelRegionMark = '0';
        }
        else this.sendBack(false);
      }
      else this.sendBack(false);
    }
  },
  // 页面销毁
  beforeDestroy() {}
};
</script>

<style lang="scss" scoped>
.bind-card {
  z-index: 100;

  ::v-deep .popup {
    width: 650px;
  }

  .el-radio__original {
    display: none !important;
  }

  .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none !important;
  }

  .bind-card-region {
    overflow: hidden;
    width: 100%;
    padding: 20px 0;

    .integral-blank {
      .info-header {
        margin-left: 20px;
      }

      .verification-method {
        margin-left: -80px;
        margin-top: 20px;
        line-height: normal;
      }

      .radio-blank {
        border: 1px solid $border1;
        padding: 0 14px;
        border-radius: 4px;
        width: 300px;
        height: 100%;
      }

      .el-form-item {
        margin-top: 20px;
        margin-left: 20px;
      }

      .el-input,
      .el-cascader,
      .el-select {
        width: 300px;
      }

      .input-special {
        width: 190px;
      }

      .el-button {
        width: 100px;
        margin-left: 10px;
        border: none;
        background-color: $main;
      }

      .sn-prompt {
        padding: 15px 20px;

        &-title {
          padding: 0;
        }
      }
    }
  }

  .patient-filing-scheme {
    padding: 0 20px 10px;

    .sn-padding-0 {
      padding: 0;
    }

    .header-title,
    .mode-title {
      font-weight: bold;
      color: $text1;
      margin: 10px 0;
    }

    .background-picture {
      margin: 16px 0 0;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      height: 180px;
      padding: 0 60px;

      .sub-text {
        font-size: 18px;
        margin: 8px 0 16px;
        color: $text3;
      }

      .button-region {
        font-size: 12px;
        background-color: $blue5;
        padding: 8px 28px;
        color: $white;
        font-weight: bold;
        border-radius: 8px;
      }
    }

    .verification-method {
      padding: 0;

      .code-region {
        font-size: 15px;
        line-height: normal;
        margin-top: 8px;
        color: $text1;
      }

      .verification-code {
        font-size: 15px;
        margin-top: 20px;
        width: 100%;

        &-label {
          width: 15%;
        }

        .el-input {
          width: 70%;
        }

        .el-button {
          margin-left: 5px;
          width: 120px;
          background-color: $main;
          border: none;
          height: 40px;
        }
      }

      .submit-btn-box {
        margin: 40px 0;

        .confirm-button {
          padding: 10px 25px;
          background-color: $main;
        }
      }
    }

    .upload-require {
      border: dashed 2px $border1;
      border-radius: 10px;
      display: inline-block;
      margin: 30px 0 10px;
      position: relative;
      padding: 20px 20px 0;

      .border-title {
        position: absolute;
        top: -20px;
        left: 20px;
        color: $text1;
        background-color: $white;
        font-size: 20px;
        padding: 0 10px;
      }

      .require-line {
        width: 100%;
        margin: 20px 0;
        display: flex;
        flex-wrap: wrap;

        .require-box {
          width: 23.5%;
          position: relative;
          text-align: center;
          margin-right: 2%;

          .require-img {
            position: relative;

            img {
              width: 100%;
              height: 100%;
            }

            .iconfont {
              position: absolute;
              bottom: -10px;
              left: 42%;
              font-size: 24px;
            }

            .icon-xuanzhong {
              color: $green4;
            }
          }

          .require-img-text {
            margin-top: 16px;
            font-size: 20px;
            color: $text3;
            text-align: center;
          }

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }

  .patient-region {
    overflow: hidden;
    width: 100%;
    padding: 20px 0;
    max-height: 80vh;

    .integral {
      overflow-x: hidden;
      overflow-y: auto;
      width: 100%;

      .integral-blank {
        .el-form-item__content-special {
          display: flex;
          justify-content: flex-start;
        }

        .el-input,
        .el-select,
        .el-cascader,
        .el-textarea,
        .el-date-editor {
          width: 300px;
        }

        .el-input-special {
          width: 170px;
        }

        .radio-blank {
          border: 1px solid $border1;
          padding: 0 14px;
          border-radius: 4px;
          width: 300px;
          display: inline-block;
        }

        .el-radio-group {
          .is-checked {
            .el-radio__inner {
              border: none;
              background-color: $main;
            }

            .el-radio__label {
              color: $main;
            }
          }
        }

        .el-button {
          margin-left: 10px;
          width: 120px;
          background-color: $main;
          border: none;
          height: 40px;
        }

        .operate-bottom {
          width: 100%;
          padding-left: 20px;
        }
      }
    }
  }

  .interaction-bottom {
    overflow: hidden;
    width: 100%;
    margin: 100px 0 10px;
    padding: 0 20px 0;

    .interaction {
      width: 120px;
      height: 40px;
      font-size: 16px;
      border: 1px solid $main;
      border-radius: 5px;
      margin-left: 10px;

      &:first-child {
        margin-left: 0;
      }

      &-confirm {
        background-color: $main;
        color: $white;
      }

      &-cancel {
        background-color: $white;
        color: $main;
      }
    }

    &-only {
      margin-top: 20px;
    }
  }

  ::v-deep .el-input {
    .el-input__inner:focus {
      border-color: $main !important;
    }
  }

  ::v-deep .el-textarea-special {
    min-height: 40px !important;

    .el-textarea__inner {
      line-height: 2;
      min-height: 40px !important;
    }

    .el-textarea__inner:focus {
      border-color: $main !important;
    }

    .el-textarea__inner::placeholder {
      font-family: "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
    }
  }
}
</style>
